import { inject, Injectable, Signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, map, Observable, of } from 'rxjs';
import {
  ASSETS_TOKEN,
  IAssetService,
  IInitService,
} from '@aksia/infrastructure';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class AssetService implements IAssetService, IInitService {
  //#region Injections

  protected readonly http = inject(HttpClient);
  protected readonly assetToken = inject(ASSETS_TOKEN);

  //#endregion

  //#region Properties

  collectionResource$!: Observable<any>;
  collection!: Signal<Map<string, unknown> | undefined>;

  //#endregion

  //#region Methods

  init(): Observable<any> {
    if (this.assetToken) {
      let loadAssetToken = Object.entries(this.assetToken).reduce(
        (acc, [key, value]) => {
          acc[key] = Array.isArray(value)
            ? forkJoin(value.map((url) => this.http.get(url)))
            : this.http.get(value);
          return acc;
        },
        {} as Record<string, Observable<any>>,
      );
      this.collectionResource$ = forkJoin(loadAssetToken).pipe(
        map((assets) => new Map(Object.entries(assets as Object))),
      );
    } else {
      this.collectionResource$ = of(new Map<string, unknown>());
    }
    this.collection = toSignal(this.collectionResource$);
    return this.collectionResource$;
  }

  //#endregion
}
